export default "__VITE_ASSET__DwrMJGt$__"